export const API_BASE =
  process.env.NODE_ENV === "production" ? "" : "http://localhost:3000";

export const EMPTY_PARTICIPANT = {
  firstname: null,
  lastname: null,
  title: null,
  email: null,
  type: "none",
  showInFolder: null,
  membershipNumber: null,
  birthyear: null,
  document: null,
  documentLocation: null,
  documentCertificateLocation: null,
  selectedPackages: [],
};

export const MemberTypes = {
  NONE: "none",
  MEMBER: "member",
  SENIOR: "senior",
  STUDENT: "student",
  PHD: "phd",
  BOOTH: "booth",
};

export const GenderTypes = ["mr", "mrs", "mx", "no_selection"];
export const SocietySections = [1, 2, 3, 4];
export const UserMemberTypes = ["A", "As", "I", "Is", "F", "YM"];
